<template>
<div class="container">
    <div class="row">
    <div class="text-center col-10">
        <h2 class="title text-danger">404 Not Found</h2>
        <h2 class="title">Stránka nebyla nalezena.</h2>
    </div>
    </div>
</div>
</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>